<h1 translate>list-retake-requests.component.title</h1>

@for (retakeRequest of retakeRequests; track retakeRequest.id) {
  <div class="retake-request-grid">
    <div class="retake-request-grid-label" translate>list-retake-requests.component.requested-at</div>
    <div class="retake-request-grid-value">{{ retakeRequest.createdAt | date: 'MMM dd, yyyy hh:mm' }}</div>

    <div class="retake-request-grid-label" translate>list-retake-requests.component.face-photo</div>
    <div class="retake-request-grid-value">
      <div class="retake-request-value-requested">
        {{ retakeRequest.facePhoto ? retakeRequest.facePhotoReason : '✅' }}
      </div>
    </div>

    <div class="retake-request-grid-label" translate>list-retake-requests.component.id-photo</div>
    <div class="retake-request-grid-value">
      <div class="retake-request-value-requested">
        {{ retakeRequest.idPhoto ? retakeRequest.idPhotoReason : '✅' }}
      </div>
    </div>

    <div class="retake-request-grid-label" translate>list-retake-requests.component.retaken-at</div>
    <div class="retake-request-grid-value">{{ retakeRequest.retakenAt | date: 'MMM dd, yyyy hh:mm' }}</div>
  </div>
}
